export default {
    "es": {
        "addresses": {
            "add": "Agregar dirección",
            "edit": "Editar dirección",
            "delete": "Eliminar dirección",
            "not_find": "No se puede encontrar una dirección con este código.",
            "id": "Id",
            "address": "Dirección",
            "address_placeholder": "Ingrese la dirección",
            "city": "Ciudad",
            "city_placeholder": "Ingrese la ciudad de la dirección",
            "state": "State",
            "state_placeholder": "Ingrese el estado de la dirección",
            "country": "País",
            "country_placeholder": "Ingrese el país de la dirección",
            "bill_address": "Dirección de facturación",
            "bill_address_placeholder": "Ingrese la dirección de facturación",
            "delivery_address": "Dirección de entrega",
            "delivery_address_placeholder": "Ingrese la dirección de entrega",
            "zip_code": "Código postal",
            "zip_code_placeholder": "Ingrese el código postal de la dirección",
            "created_at": "Creado en",
            "report_title": "Reporte de Direcciones"
        },
        "attachments": {
            "add": "Agregar Adjunto",
            "edit": "Editar Adjunto",
            "delete": "Eliminar Adjunto",
            "not_find": "No se puede encontrar un Adjunto con este código.",
            "id": "Id",
            "attachments": "Adjuntos",
            "add_attachments": "Agregar Adjuntos",
            "description": "Descripcion",
            "description_placeholder": "Ingrese la Descripcion del adjunto",
            "date": "Fecha",
            "created_at": "Creado en",
            "report_title": "Reporte de Adjuntos"
        },
        "auth": {
            "failed": "Estas credenciales no coinciden con nuestros registros.",
            "throttle": "Demasiados intentos de inicio de sesión. Por favor intente de nuevo en {seconds} segundos."
        },
        "comments": {
            "add": "Agregar comment",
            "edit": "Editar comment",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un comment con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del comment",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de Comments"
        },
        "commissions": {
            "calculated_commission": "Comisión calculada",
            "commission_percentage": "Porcentaje de comisión",
            "created_at": "Creado en",
            "currency": "Moneda",
            "customer_name": "Nombre del cliente",
            "exchange_rate": "Tipo de cambio",
            "liquidation_date": "Fecha de liquidación",
            "quotation_folio": "Folio de cotización",
            "sale_folio": "Folio de venta",
            "sale_subtotal": "Subtotal de la venta",
            "sale_subtotal_mxn": "Subtotal de la venta (MXN)",
            "sale_total_mxn": "Total de la venta (MXN)",
            "sale_total": "Total de la venta",
            "seller_name": "Nombre del vendedor"
        },
        "currencies": {
            "add": "Agregar moneda",
            "edit": "Editar moneda",
            "delete": "Eliminar moneda",
            "not_find": "No se puede encontrar la moneda con este código.",
            "id": "Id",
            "name": "Moneda",
            "name_placeholder": "Ingrese la moneda",
            "code": "Código",
            "code_placeholder": "Ingrese el código de moneda",
            "created_at": "Creado en",
            "report_title": "Reporte de Moneda"
        },
        "customer_addresses": {
            "add": "Agregar Direccion",
            "edit": "Editar Direccion",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un Direccion con este código.",
            "id": "Id",
            "address_name": "Nombre",
            "address_name_placeholder": "Ingresa el Nombre de la Direccion",
            "street_name": "Calle",
            "street_name_placeholder": "Ingresa el Calle de la Direccion",
            "street_number": "Numero",
            "street_number_placeholder": "Ingresa el Numero de la Direccion",
            "city": "Ciudad",
            "city_placeholder": "Ingresa el Ciudad de la Direccion",
            "state": "Estado",
            "state_placeholder": "Ingresa el Estado de la Direccion",
            "country": "Pais",
            "country_placeholder": "Ingresa el Pais de la Direccion",
            "address_type_id": "Tipo",
            "address_type_id_placeholder": "Ingresa el Tipo de la Direccion",
            "zip_code": "Codigo Postal",
            "zip_code_placeholder": "Ingresa el Codigo Postal de la Direccion",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de Direcciones"
        },
        "customer_contacts": {
            "add": "Agregar contacto",
            "edit": "Editar contacto",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un contacto con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del contacto",
            "email": "Correo electronico",
            "email_placeholder": "Ingresa el correo electronico del contacto",
            "phone": "Teléfono",
            "phone_placeholder": "Ingresa el número de teléfono del contacto",
            "ext": "Extension",
            "ext_placeholder": "Ingresa la extension de teléfono del contacto",
            "cellphone": "Telefono celular",
            "cellphone_placeholder": "Ingresa el telefono celular del contacto",
            "position": "Puesto",
            "position_placeholder": "Ingresa el puesto del contacto",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de CustomerContacts"
        },
        "customers": {
            "add": "Agregar cliente",
            "edit": "Editar cliente",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un cliente con este código.",
            "id": "Id",
            "customer": "Nombre",
            "totalCM": "Total de ventas por mes",
            "totalCY": "Total de ventas por año",
            "totalAM": "Monto total de ventas por mes",
            "totalAY": "Monto total de ventas por año",
            "tradename": "Nombre Comercial",
            "tradename_placeholder": "Ingresa el nombre comercial del cliente",
            "phone": "Teléfono",
            "phone_placeholder": "Ingresa el número de teléfono del cliente",
            "contact": "Contacto",
            "contact_placeholder": "Ingresa el contacto del cliente",
            "address": "Dirección",
            "address_placeholder": "Ingresa la dirección del cliente",
            "city": "Ciudad",
            "city_placeholder": "Ingresa la ciudad del cliente",
            "state": "Estado",
            "state_placeholder": "Ingresa el estado del cliente",
            "country": "País",
            "country_placeholder": "Ingresa el país del cliente",
            "zip_code": "Código Postal",
            "zip_code_placeholder": "Ingresa el código postal del cliente",
            "email": "Correo",
            "email_placeholder": "Ingresa el correo electrónico del cliente",
            "rfc": "RFC",
            "rfc_placeholder": "Ingresa el RFC del cliente",
            "mining_group_id": "Grupo Minero",
            "mining_group_id_placeholder": "Ingresa el grupo minero del cliente",
            "payment_terms": "Terminos de pago",
            "payment_terms_placeholder": "Ingresa los terminos de pago del cliente",
            "assignmet_type_id": "Tipo de asignacion",
            "assignmet_type_id_placeholder": "Ingresa el tipo de asignacion del cliente",
            "assigned_to": "Asignado a",
            "assigned_to_placeholder": "Ingresa a quien se asigna el cliente",
            "seller": "Vendedor",
            "seller_to_placeholder": "Selecciona el Vendedor",
            "filter_seller": "Filtrar por Vendedor",
            "seller_placeholder": "Ingresa a quien se asigna el cliente",
            "created_at": "Creado en",
            "report_title": "Reporte de Clientes",
            "assign": "Asignar",
            "has_sales": "Tiene Ventas",
            "createdBy": "Creado por",
            "contact_status": "Estatus del Contacto",
            "contact_status_select": "Selecciona el Estatus del Contacto",
            "customer_to_placeholder": "Selecciona el Cliente",
            "customer_filter": "Filtrar por Cliente",
            "prospect_reports": "Reportes de Prospectos",
            "new_prospectings": "Nuevos Prospectos",
            "prospect_status": "Inactividad",
            "createdByUser": "Creado por",
            "mention": "¿Como nos conoce?",
            "mention_select": "Selecciona una opción",
            "prospect": "Prospecto",
            "lead": "LEAD",
            "has_sale": "Prospecto con venta"
        },
        "dashboard": {
            "email": "Correo electrónico",
            "password": "Contraseña",
            "keep_connected": "Recordarme",
            "forgot_password": "Restablecer",
            "login": "Iniciar sesión",
            "logout": "Cerrar sesión",
            "reset_password": "Restablecer la contraseña",
            "send_reset_link": "Enviar el enlace de reinicio",
            "password_confirmation": "Confirmación de contraseña",
            "still_having_trouble": "¿Sigues teniendo problemas para iniciar sesión?",
            "havent_account": "No tienes una cuenta?",
            "back_login": "Volver a Inicio de sesión",
            "register": "Crear cuenta",
            "annual_sales": "Ventas Anuales",
            "welcome": "Bienvenido",
            "description": "Descripción",
            "seller_id": "Vendedor",
            "month": "Mes",
            "year": "Año"
        },
        "email": {
            "email": "Correo",
            "email_placeholder": "Ingresa la dirección de correo",
            "subject": "Asunto",
            "subject_placeholder": "Ingresa el asunto",
            "body": "Mensaje",
            "body_placeholder": "Ingresa el mensaje"
        },
        "errors": {
            "fatal_error": "Se produjo un error fatal, póngase en contacto con nosotros.",
            "generic_error": "Ha ocurrido un error. Por favor intente de nuevo.",
            "unauthorized": "No autorizado.",
            "connection_error": "Error de conexión",
            "action_unauthorized": "No estas autorizado para realizar esta acción"
        },
        "feedback": {
            "rate": "¿Como te parece este sistema?",
            "comment": "¿Cuéntanos cómo ha sido tu experiencia?",
            "contact_me": "Controlla puede comunicarse conmigo en relación con mis comentarios."
        },
        "front": {
            "added_successfully": "Ha sido agregado con éxito.",
            "updated_successfully": "Ha sido actualizado con éxito.",
            "deleted_successfully": "Ha sido eliminado con éxito.",
            "imported_successfully": "Ha sido importado con éxito.",
            "send_successfully": "Ha sido enviado con éxito.",
            "delete_modal": "Eliminar",
            "delete_confirmation": "¿Seguro que quieres eliminar la {:model} {attribute}?",
            "delete_confirmation2": "¿Seguro que quieres eliminar el {:model} {attribute}?",
            "action_confirmation": "¿Seguro que deseas :action esta {:model}?",
            "action_confirmation2": "¿Seguro que deseas :action este {:model}?",
            "import_modal": "Importar {:model} desde un archivo CSV o Excel",
            "accept_modal": "Aceptar todas",
            "accept_confirmation": "¿Seguro que quieres aceptar todas las comisiones?",
            "reject_modal": "Rechazar todas",
            "reject_confirmation": "¿Seguro que quieres rechazar todas las comisiones?",
            "propouse_modal": "Proponer todas",
            "propouse_confirmation": "¿Seguro que quieres proponer todas las comisiones?",
            "close_modal": "Cerrar todas",
            "close_confirmation": "¿Seguro que quieres cerrar todas las comisiones aceptadas?",
            "general_supplier_modal": "Proveedor General",
            "general_supplier_confirmation": "Esta cotizacion tiene proveedor General {attribute}"
        },
        "invoices": {
            "amount": "Monto de la factura",
            "invoice_number": "Numero de factura",
            "created_at": "Creada el:",
            "payment_type": "Forma de pago",
            "payment_date": "Pagado el",
            "actions": "Acciones",
            "status": "Status",
            "invoice": "Factura",
            "invoiced_date": "Fecha de factura"
        },
        "invoices_payments": {
            "amount_to_add": "Monto a abonar",
            "amount": "Monto",
            "payment_type": "Forma de pago:",
            "payment_date": "Pagado el:",
            "created_at": "Creado el:",
            "actions": "Acciones"
        },
        "login": {
            "email": "Correo electrónico",
            "password": "Contraseña",
            "keep_connected": "Recordarme",
            "forgot_password": "Restablecer",
            "login": "Iniciar sesión",
            "logout": "Cerrar sesión",
            "reset_password": "Restablecer la contraseña",
            "send_reset_link": "Enviar el enlace de reinicio",
            "password_confirmation": "Confirmación de contraseña",
            "still_having_trouble": "¿Sigues teniendo problemas para iniciar sesión?",
            "havent_account": "No tienes una cuenta?",
            "back_login": "Volver a Inicio de sesión",
            "register": "Crear cuenta",
            "welcome": "Bienvenido",
            "description": "Descripción"
        },
        "mining_groups": {
            "add": "Agregar grupo minero",
            "edit": "Editar grupo minero",
            "delete": "Eliminar grupo minero",
            "not_find": "No se puede encontrar un grupo minero con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingrese el nombre del grupo minero",
            "razon_social": "Razón Social",
            "razon_social_placeholder": "Ingrese la razón social del grupo minero",
            "delivery_address": "Dirección de entrega",
            "delivery_address_placeholder": "Ingrese la dirección de entrega del grupo minero",
            "comments": "Comentarios",
            "comments_placeholder": "Ingrese comentarios del grupo minero",
            "created_at": "Creado en",
            "report_title": "Reporte de Grupos Mineros"
        },
        "notifications": {
            "empty_title": "No hay notificaciones en este momento",
            "empty_msg": "Cuando tu equipo empiece a hacer cosas, mostraremos las notificaciones aquí.",
            "add_new_user": "Usuario Nuevo!",
            "add_new_user_message": "agrego un nuevo usuario"
        },
        "pagination": {
            "previous": "« Anterior",
            "next": "Siguiente »"
        },
        "passwords": {
            "password": "Las contraseñas deben tener al menos seis caracteres y coincidir con la confirmación.",
            "reset": "¡Tu contraseña ha sido restablecida!",
            "sent": "Hemos enviado por correo electrónico el enlace para restablecer su contraseña!",
            "token": "Este token de restablecimiento de contraseña no es válido.",
            "user": "No podemos encontrar un usuario con esa dirección de correo electrónico.",
            "cant_login": "¿No puedes iniciar sesión?",
            "very_weak": "Débil",
            "weak": "Normal",
            "good": "Buena",
            "strong": "Sólida",
            "very_strong": "Muy Sólida"
        },
        "payment_methods": {
            "add": "Agregar método de pago",
            "edit": "Editar método de pago",
            "delete": "Eliminar método de pago",
            "not_find": "No se puede encontrar un método de pago con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del método de pago",
            "created_at": "Creado en",
            "report_title": "Reporte de Métodos de Pago"
        },
        "product_categories": {
            "add": "Agregar categoria de producto",
            "edit": "Editar categoria de producto",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un categoria de producto con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del categoria de producto",
            "description": "Descripcion",
            "description_placeholder": "Ingresa la descripcion de la categoria de producto",
            "created_at": "Creado en",
            "report_title": "Reporte de ProductCategories"
        },
        "products": {
            "add": "Agregar producto",
            "edit": "Editar producto",
            "delete": "Eliminar producto",
            "not_find": "No se puede encontrar un producto con este código.",
            "id": "Id",
            "sku": "Código de Producto",
            "sku_placeholder": "Ingresa el código del producto",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del producto",
            "description": "Descripción",
            "description_placeholder": "Ingresa la descripcion del producto",
            "number_part": "Número de parte",
            "number_part_placeholder": "Ingresa el número de parte",
            "price": "Costo",
            "price_placeholder": "Ingresa el costo del producto",
            "unit_measurement_id": "Unidad de Medida",
            "unit_measurement_id_placeholder": "Ingresa la unidad de medida del producto",
            "unit_measurement": "Unidad de Medida",
            "unit_measurement_placeholder": "Ingresa la unidad de medida del producto",
            "currency_id": "Moneda",
            "currency_id_placeholder": "Ingresa la moneda del producto",
            "product_category_id": "Categoria",
            "product_category_id_placeholder": "Ingresa la categoria del producto",
            "tech_sheet": "Ficha Tecnica",
            "security_sheet": "Hoja de Seguridad",
            "created_at": "Creado en",
            "report_title": "Reporte de Productos",
            "top_suppliers": "Principales Proveedores",
            "oc_number": "Orden de Compra",
            "supplier": "Proveedor",
            "purchase_date": "Fecha de Compra"
        },
        "purchase_orders": {
            "add": "Agregar orden de compra",
            "edit": "Editar orden de compra",
            "delete": "Eliminar orden de compra",
            "not_find": "No se puede encontrar una orden de compra con este código.",
            "approved": "La orden de compra ya esta aprobada",
            "cancelled": "La orden de compra ya esta cancelada",
            "paid": "La orden de compra ya esta pagada",
            "pending": "La orden de compra esta pendiente",
            "send": "La orden de compra fue enviada",
            "attachments": "Adjuntos",
            "cus": "Cliente",
            "id": "Id",
            "folio": "Folio",
            "folio_placeholder": "Ingrese el folio de la orden de compra",
            "delivery_time": "Tiempo de Entrega",
            "delivery_time_placeholder": "Ingrese el tiempo de entrega de la orden de compra",
            "subtotal": "Subtotal",
            "subtotal_placeholder": "Ingrese el subtotal de la orden de compra",
            "total": "Total",
            "total_placeholder": "Ingrese el total de la orden de compra",
            "fletes": "Flete",
            "fletes_placeholder": "Ingrese el flete de la orden de compra",
            "shipping_address_id": "Dirección de Envio",
            "shipping_address_id_placeholder": "Ingrese la dirección de envio de la orden de compra",
            "customer_id": "Cliente",
            "customer_id_placeholder": "Ingrese al cliente de la orden de compra",
            "status": "Estatus",
            "status_placeholder": "Ingrese el estatus de la orden de compra",
            "supplier_id": "Proveedor",
            "supplier_id_placeholder": "Ingrese el proveedor de la orden de compra",
            "billing_address_id": "Dirección de Facturación",
            "billing_address_id_placeholder": "Ingrese la dirección de facturación de la orden de compra",
            "authorization_by": "Autorizado por",
            "authorization_by_placeholder": "Ingrese el usuario que autoriza la orden de compra",
            "currency_id": "Moneda",
            "currency_id_placeholder": "Ingrese la moneda de la orden de compra",
            "quotation_id": "Cotización",
            "quotation_id_placeholder": "Ingrese la cotización de la orden de compra",
            "cancelled_date": "Fecha de Cancelación",
            "cancelled_date_placeholder": "Ingrese la fecha de cancelación de la orden de compra",
            "authorization_date": "Fecha de Autorización",
            "authorization_date_placeholder": "Ingrese la fecha de autorización de la orden de compra",
            "created_by_id": "Creado por",
            "created_by_id_placeholder": "Ingresa al usuario que creó la orden de compra",
            "cancelled_by_id": "Cancelado por",
            "cancelled_by_id_placeholder": "Ingresa al usuario que canceló la orden de compra",
            "authorization_by_id": "Autorizado por",
            "authorization_by_id_placeholder": "Ingresa al usuario que autorizó la orden de compra",
            "total_mn": "Total MN",
            "total_mn_placeholder": "Ingrese el total de la orden de compra",
            "exchange_rate": "Tipo de Cambio",
            "exchange_rate_placeholder": "Ingrese el tipo de cambio de la orden de compra",
            "tax": "Impuesto",
            "tax_placeholder": "Ingrese el impuesto de la orden de compra",
            "comments": "Comentarios",
            "comments_placeholder": "Ingresa los comentarios de la orden de compra",
            "created_at": "Creado el",
            "report_title": "Reporte de Orden de Compras",
            "email_sent": "Enviado",
            "guide_number": "Número de guía",
            "parcel": "Paquetería",
            "date_send": "Fecha de envío",
            "arrival_date": "Fecha de llegada",
            "partiallyreceived": "Recibido parc.",
            "delivery_unit": "Unidad de tiempo de entrega",
            "delivery_unit_placeholder": "Selecciona la unidad de tiempo de entrega",
            "payment_date_limit": "Fecha limite de pago",
            "payment_date_limit_placeholder": "Selecciona la fecha limite de pago",
            "general": "General",
            "tracking": "Seguimiento",
            "user_display": "Usuario",
            "notes": "Notas",
            "latest_tracking_display": "Último seguimiento"
        },
        "purchase_orders_detail": {
            "add": "Agregar detalle de orden de compra",
            "edit": "Editar detalle de orden de compra",
            "delete": "Eliminar detalle de orden de compra",
            "not_find": "No se puede encontrar un detalle de orden de compra con este código.",
            "id": "Id",
            "quantity": "Cantidad",
            "quantity_placeholder": "Ingresa la cantidad del detalle de orden de compra",
            "unit_price": "Precio Unitario",
            "unit_price_placeholder": "Ingresa el precio unitario del detalle de orden de compra",
            "total": "Total",
            "total_placeholder": "Ingresa el total del detalle de orden de compra",
            "utility": "Utilidad",
            "utility_placeholder": "Ingresa la utilidad del detalle de orden de compra",
            "product_id": "Producto",
            "product": "Producto",
            "product_id_placeholder": "Ingresa el producto del detalle de orden de compra",
            "purchase_order_id": "Orden de Compra",
            "purchase_order_id_placeholder": "Ingresa la orden de compra del detalle de orden de compra",
            "quotation_id": "Cotizacion",
            "quotation_id_placeholder": "Ingresa la cotizacion del detalle de orden de compra",
            "number_part": "# parte",
            "number_part_placeholder": "Ingrese el # parte del detalle de la cotización",
            "created_at": "Creado en",
            "report_title": "Reporte de Detalle de Orden de Compras",
            "receptions": "Envios Proveedor y Recepciones",
            "received_on": "Recibido el",
            "receptions_select": "Seleccione un producto para recibir",
            "receptions_ordered": "Cantidad recibida",
            "ordered_quantity": "Cantidad ordenada",
            "date_ordered": "Fecha de la cantidad recibida",
            "send": "Enviar producto",
            "sent": "Enviado",
            "to_sent": "Cantidad a enviar",
            "add_send": "Agregar envío",
            "send_quantity": "Cantidad enviada",
            "cantsend_quantity": "Cantidad a enviar",
            "send_placeholder": "Ingrese la cantidad a enviar",
            "guide_number": "Número de guía",
            "guide_number_placeholder": "Ingrese el número de guía",
            "parcel": "Paquetería",
            "parcel_placeholder": "Ingresa nombre de la paquetería",
            "date_send": "Fecha de envío",
            "date_send_placeholder": "Ingresa la fecha de envío",
            "arrival_date": "Fecha de llegada",
            "arrival_date_placeholder": "Ingresa la fecha de llegada",
            "invoice_number": "Folio",
            "date": "Fecha",
            "amount": "Monto",
            "status": "Estatus",
            "expire": "Vencimiento",
            "reception_orders_sent": "Recibido  \/ Ordenado",
            "recived": "Recibido",
            "supplier_shipping": "Envio de proveedor",
            "supplier": "Proveedor",
            "oc": "Orden de compra",
            "to_recived": "Cantidad a recibir",
            "supplier_shipping_detail": "Detalles de envios de proveedores",
            "oc_detail": "Detalles de orden de compra",
            "actions": "Acciones",
            "received_quantity": "Cantidad Recibida"
        },
        "quotations": {
            "add": "Agregar cotización",
            "edit": "Editar cotización",
            "delete": "Eliminar cotización",
            "not_find": "No se puede encontrar una cotización con este código.",
            "approved": "La cotización ya esta aprobada",
            "cancelled": "La cotización esta cancelada",
            "paid": "La cotización esta pagada",
            "sold": "La cotización fue vendida",
            "action_sold": "vender",
            "action_cancelled": "cancelar",
            "action_pending": "devolver a pendiente",
            "id": "Id",
            "folio": "Número de Folio",
            "folio_placeholder": "Ingresa el número de folio de la cotización",
            "type_utility": "Tipo de Utilidad",
            "type_utility_placeholder": "Ingresa el tipo de utilidad de la cotización",
            "delivery_time": "Tiempo de Entrega",
            "delivery_time_placeholder": "Ingresa el tiempo de entrega de la cotización",
            "flete": "Flete",
            "flete_placeholder": "Ingresa el flete de la cotización",
            "discount": "Descuento",
            "discount_utility_placeholder": "Ingresa el descuento de la cotización",
            "total": "Total",
            "total_placeholder": "Ingresa el total de la cotización",
            "subtotal": "Subtotal",
            "subtotal_placeholder": "Ingresa el subtotal de la cotización",
            "tax_rate": "Tasa de Impuesto",
            "tax_rate_placeholder": "Ingrese la tasa de impuesto de la cotización",
            "sales_tax": "Impuesto de Venta",
            "sales_tax_placeholder": "Ingresa el impuesto de venta de la cotización",
            "utility": "Utilidad",
            "utility_placeholder": "Ingresa la utilidad de la cotización",
            "comments": "Comentarios",
            "comments_placeholder": "Ingresa los comentarios de la cotización",
            "exchange_rate": "Tipo de Cambio",
            "exchange_rate_placeholder": "Ingresa el tipo de cambio de la cotización",
            "status": "Estatus",
            "status_placeholder": "Ingresa el estatus de la cotización",
            "currency_id": "Moneda",
            "currency_id_placeholder": "Ingresa la moneda de la cotización",
            "customer_id": "Cliente",
            "customer_id_placeholder": "Ingresa al cliente de la cotización",
            "customer": "Cliente",
            "customer_placeholder": "Ingresa al cliente de la cotización",
            "seller_id": "Vendedor",
            "seller_id_placeholder": "Ingresa al vendedor de la cotización",
            "cancelled_date": "Fecha de Cancelación",
            "cancelled_date_placeholder": "Ingresa la fecha de cancelación de la cotización",
            "authorization_date": "Fecha de Autorización",
            "authorization_date_placeholder": "Ingresa la fecha de autorización de la cotización",
            "created_by_id": "Creado por",
            "created_by_id_placeholder": "Ingresa al usuario que creó la cotización",
            "cancelled_by_id": "Cancelado por",
            "cancelled_by_id_placeholder": "Ingresa al usuario que canceló la cotización",
            "authorization_by_id": "Autorizado por",
            "authorization_by_id_placeholder": "Ingresa al usuario que autorizó de la cotización",
            "total_mn": "Total MN",
            "total_mn_placeholder": "Ingrese el total de la cotización",
            "order_customer": "OC Cliente",
            "order_customer_placeholder": "Ingrese la orden de compra del cliente",
            "delivery_address": "Dirección de Entrega",
            "delivery_address_placeholder": "Ingrese la dirección de entrega de la cotización",
            "printing_date": "FECHA DE IMPRESIÓN",
            "payment_conditions": "Condiciones de Pago",
            "payment_conditions_placeholder": "Ingrese la las condiciones de pago de la cotización",
            "created_at": "Creado el",
            "report_title": "Reporte de Cotizaciones",
            "report_loss_title": "Reporte de Cotizaciones Perdidas",
            "general_delivery_time_flag": "Tiempo de Entrega General",
            "email_sent": "Enviado",
            "pending": "Pendiente",
            "loss_reason_id": "Razon de perdida",
            "loss_reason_id_placeholder": "Selecciona la razon de perdida de la cotización",
            "loss_description": "Descripcion de perdida",
            "loss_description_placeholder": "Ingrese la descripcion de perdida de la cotización",
            "customer_contact_id": "Contacto del cliente",
            "customer_contact_id_placeholder": "Selecciona el contacto del cliente",
            "customer_address_id": "Direccion de envío",
            "customer_address_id_placeholder": "Selecciona la direccion de envío",
            "delivery_unit": "Unidad de tiempo de entrega",
            "delivery_unit_placeholder": "Selecciona la unidad de tiempo de entrega",
            "purchase_order_file": "Archivo de la Orden de Compra",
            "supplier_quotations": "Cotizaciones de provedor",
            "add_supplier_quotations": "Agregar Cotizaciones de provedor",
            "supplier_id": "Provedor",
            "supplier_id_placeholder": "Selecciona el provedor",
            "attachment": "Adjunto",
            "days": "dias",
            "months": "meses"
        },
        "quotations_detail": {
            "add": "Agregar detalle de cotización",
            "edit": "Editar detalle de cotización",
            "delete": "Eliminar detalle de cotización",
            "last_update": "Última modificación",
            "not_find": "No se puede encontrar un detalle de cotización con este código.",
            "id": "Id",
            "quantity": "Cantidad",
            "quantity_placeholder": "Ingrese la cantidad del detalle de la cotización",
            "unit_price": "Costo Unitario",
            "unit_price_placeholder": "Ingrese el costo unitario del detalle de la cotización",
            "price": "Precio",
            "price_placeholder": "Ingrese el precio del detalle de la cotización",
            "total": "Total",
            "total_placeholder": "Ingrese el total del detalle de la cotización",
            "flete": "Flete",
            "flete_placeholder": "Ingrese el flete del detalle de la cotización",
            "fletes": "Flete",
            "fletes_placeholder": "Ingrese el flete del detalle de la cotización",
            "utility": "Utilidad %",
            "utility_placeholder": "Ingrese la utilidad del detalle de la cotización",
            "utility_amount": "Utilidad $",
            "utility_amount_placeholder": "Ingrese la utilidad % del detalle de la cotización",
            "utility_subtotal": "Subtotal de Utilidad $",
            "utility_subtotal_placeholder": "Ingrese la utilidad % del detalle de la cotización",
            "subtotal": "Subtotal",
            "subtotal_placeholder": "Ingrese la utilidad $ del detalle de la cotización",
            "supplier_id": "Proveedor",
            "supplier_id_placeholder": "Ingrese el proveedor del detalle de la cotización",
            "quotation_id": "Cotización",
            "quotation_id_placeholder": "Ingrese la cotización del detalle de la cotización",
            "product_id": "Producto",
            "product_id_placeholder": "Ingrese el producto del detalle de la cotización",
            "number_part": "# parte",
            "number_part_placeholder": "Ingrese el # parte del detalle de la cotización",
            "pu": "P U",
            "pup": "P U P",
            "unit_cost": "C U",
            "sub_unit_cost": "Subtotal",
            "utility_sub": "Sub utilidad",
            "individual_delivery_time": "Tiempo de Entrega",
            "created_at": "Creado en",
            "report_title": "Reporte de Detalle de Cotizaciones",
            "unit_measurement_display": "Unidad de Medida"
        },
        "receptions": {
            "actions": "Acciones",
            "created_by": "Elaborado Por:",
            "product": "Producto",
            "quantity": "Cantidad disponible a recibir",
            "quantity_ordered": "Cantidad Ordenada",
            "received_quantity": "Cantidad Recibida",
            "to_recived": "Recibir:",
            "total_received_quantity": "Cantidad Recibida",
            "total_receptions_all": "Total recibido",
            "alerts": {
                "supplier_shipment": "Recepción denegada",
                "supplier_shipment_text": "Es necesario seleccionar envío de proveedor"
            }
        },
        "register": {
            "title": "Regístrate para obtener tu cuenta",
            "email": "Correo electrónico",
            "name": "Nombre de usuario",
            "password": "Contraseña",
            "register": "Crear cuenta",
            "message": "Al registrarte, confirmas que has leído y aceptado nuestros <a href=\"\/login\" class=\"content-vertical text-secondary\"> Términos de uso<\/a> y nuestra <a href=\"\/login\"> Política de privacidad<\/a>.",
            "back_login": "¿Ya tienes una cuenta de Controlla? Iniciar sesión",
            "very_weak": "Débil",
            "weak": "Normal",
            "good": "Buena",
            "strong": "Sólida",
            "very_strong": "Muy Sólida"
        },
        "reset": {
            "subject": "Restablece tu contraseña de Controlla",
            "line_1": "Recibió este correo electrónico porque recibimos una solicitud de restablecimiento de contraseña para su cuenta.",
            "action": "Restablecer contraseña",
            "line_2": "Este enlace de restablecimiento de contraseña caducará en {count} minutos.",
            "line_3": "Si no solicitó un restablecimiento de contraseña, no se requiere ninguna otra acción."
        },
        "sale_imports": {
            "supplier_name": "Proveedor",
            "total_cost": "Costo total",
            "total_cost_mxn": "Costo total (MXN)",
            "amount": "Monto de importacion (MXN)",
            "percent": "Porcentaje de importacion",
            "import_total": "Monto total de importacion",
            "type": "Tipo de importacion",
            "actions": "Acciones"
        },
        "sale_other_expenses": {
            "amount": "Monto",
            "amount_mxn": "Monto (MXN)",
            "concept": "Concepto",
            "expense_date": "Fecha",
            "actions": "Acciones"
        },
        "sale_tracings": {
            "add": "Agregar seguimiento",
            "edit": "Editar seguimiento",
            "delete": "Eliminar seguimiento",
            "not_find": "No se puede encontrar un seguimiento con este código.",
            "id": "Id",
            "text": "Detalle",
            "text_placeholder": "Ingresa el detalle del seguimiento",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de seguimiento"
        },
        "sales": {
            "add": "Agregar venta",
            "edit": "Editar venta",
            "delete": "Eliminar venta",
            "not_find": "No se puede encontrar una venta con este código.",
            "invoiced": "Facturas",
            "uninvoiced": "Vendido",
            "paid": "Pagado",
            "unpaid": "Facturado",
            "attachments": "Adjuntos",
            "invoice": "Factura",
            "add_invoices": "Agregar facturas",
            "add_invoice_payment": "Agregar facturas y pagos",
            "payment": "Pago",
            "id": "Id",
            "folio": "Folio",
            "folio_placeholder": "Ingresa el folio de la venta",
            "delivery_time": "Tiempo de Entrega",
            "delivery_time_placeholder": "Ingresa el tiempo de entrega de la venta",
            "invoice_number": "No. Factura",
            "description_invoiced": "Detalles de las facturas",
            "invoice_number_placeholder": "Ingresa el numero de factura de la venta",
            "total": "Total",
            "total_placeholder": "Ingresa el total de la venta",
            "status": "Estatus",
            "status_placeholder": "Ingresa el estatus de la venta",
            "currency_id": "Moneda",
            "currency_id_placeholder": "Ingresa la moneda de la venta",
            "currency_invoice_placeholder": "Ingresa la moneda de la factura",
            "customer_id": "Cliente",
            "customer_id_placeholder": "Ingresa el cliente de la venta",
            "seller_id": "Vendedor",
            "seller_id_placeholder": "Ingresa el vendedor de la venta",
            "purchase_order_placeholder": "Ingresa la orden de compra de la venta",
            "quotation_id": "Cotización",
            "quotation_id_placeholder": "Ingresa la cotización de la venta",
            "quotation_folio": "Cotización",
            "quotation_folio_placeholder": "Ingresa la cotización de la venta",
            "payment_method_id": "Método de Pago",
            "payment_method_id_placeholder": "Ingresa el método de pago de la venta",
            "add_payment": "Agregar Pago",
            "cancelled_date": "Fecha de Cancelación",
            "cancelled_date_placeholder": "Ingresa la fecha de cancelación de la venta",
            "authorization_date": "Fecha de Autorización",
            "authorization_date_placeholder": "Ingresa la fecha de autorización de la venta",
            "date": "Fecha de factura",
            "date_placeholder": "Ingresa la fecha de factura",
            "liquidation_date": "Fecha de liquidacion",
            "liquidation_date_placeholder": "Ingresa la fecha de liquidacion",
            "created_by_id": "Creado por",
            "created_by_id_placeholder": "Ingresa al usuario que creó la venta",
            "cancelled_by_id": "Cancelado por",
            "cancelled_by_id_placeholder": "Ingresa al usuario que canceló la venta",
            "authorization_by_id": "Autorizado por",
            "authorization_by_id_placeholder": "Ingresa al usuario que autorizó de la venta",
            "total_mn": "Total MN",
            "total_mn_placeholder": "Ingrese el total de la venta",
            "amount_invoice": "Monto",
            "amount_invoice_placeholder": "Ingrese el total de la factura",
            "exchange_rate": "Tipo de Cambio",
            "exchange_rate_placeholder": "Ingrese el tipo de cambio de la venta",
            "remaining": "Restante",
            "remaining_placeholder": "Ingrese el restante de la venta",
            "comments": "Comentarios",
            "comments_placeholder": "Ingresa los comentarios de la venta",
            "order_customer": "OC Cliente",
            "order_customer_placeholder": "Ingrese la orden de compra del cliente",
            "digits_card": "Terminación de la tarjeta",
            "digits_card_placeholder": "Ingrese los últimos 4 dígitos",
            "created_at": "Creado el",
            "payment_date": "Fecha de pago",
            "report_title": "Reporte de Ventas",
            "supplier": "Proveedor",
            "cost": "Costo",
            "flete": "Flete",
            "subtotal": "Subtotal",
            "utility": "Utilidad",
            "utility_percent": "%",
            "created_at_oc": "Fecha OC",
            "no": "No",
            "delivery_date": "Fecha de entrega",
            "delivery_status": "Estatus de la entrega"
        },
        "sales_detail": {
            "add": "Agregar detalle de venta",
            "edit": "Editar detalle de venta",
            "delete": "Eliminar detalle de venta",
            "not_find": "No se puede encontrar un detalle de venta con este código.",
            "id": "Id",
            "quantity": "Cantidad",
            "quantity_placeholder": "Ingresa la cantidad del detalle de venta",
            "unit_price": "Precio Unitario",
            "unit_price_placeholder": "Ingresa el precio unitario del detalle de venta",
            "total": "Total",
            "total_placeholder": "Ingresa el total del detalle de venta",
            "utility": "Utilidad",
            "utility_placeholder": "Ingresa la utilidad del detalle de venta",
            "created_at": "Creado en",
            "report_title": "Reporte de Detalle de Ventas"
        },
        "sending_receptions": {
            "actions": "Acciones",
            "product": "Producto",
            "quantity_ordered": "Ordenado \/ Recibido \/ Enviado",
            "quantity_to_send": "Cantidad a enviar",
            "parcel": "Paquetería",
            "guide_number": "Número de guía",
            "amount": "Costo del envio (MXN)",
            "shipping_date": "Fecha de envío",
            "created_by": "Elaborado por:",
            "sending_detail": "Cantidad enviada",
            "purchase_order": "Orden de Compra"
        },
        "strings": {
            "dashboard": "Inicio",
            "overview": "Inicio",
            "tasks": "Tareas",
            "task": "Tarea",
            "users": "Usuarios",
            "user": "Usuario",
            "customer": "Cliente",
            "customers": "Clientes",
            "quotation": "Cotizacion",
            "quotations": "Cotizaciones",
            "quotation_detail": "Partida",
            "quotation_details": "Partidas",
            "purchase_order": "Orden de compra",
            "oc_number": "# O.C.",
            "purchase_orders": "Ordenes de Compra",
            "purchase_order_trackings": "Seguimiento",
            "sale": "Venta",
            "sales": "Ventas",
            "supplier": "Proveedor",
            "suppliers": "Proveedores",
            "product": "Producto",
            "products": "Productos",
            "mining_group": "Grupo Minero",
            "mining_groups": "Grupos Mineros",
            "attachments": "Adjuntos",
            "attachment": "Adjunto",
            "see": "Ver",
            "download": "Descargar",
            "see_comments": "Ver comentarios",
            "packing_list": "Packing List",
            "tag": "Etiqueta",
            "comments": "Comentarios",
            "comment": "comentario",
            "addpayments": "Pagos",
            "payments": "Pagos",
            "add_amount": "Ingresa la cantidad",
            "amount": "Cantidad",
            "payment_method": "Metodo de pago",
            "method": "Metodo de pago",
            "payment_date": "Fecha",
            "date": "Fecha",
            "commissions": "Comisiones",
            "commission": "Comisión",
            "addresses": "Direcciones",
            "address": "Dirección",
            "contacts": "Contactos",
            "contact": "Contacto",
            "product_categories": "Categorias de producto",
            "product_category": "Categoria de producto",
            "sale_tracings": "Seguimientos",
            "sale_tracing": "Seguimiento",
            "description": "Un resumen de sus {attribute}",
            "search": "Buscar",
            "filters": "Filtros",
            "clear": "Limpiar",
            "apply": "Aplicar",
            "select_date": "Selecciona una fecha",
            "multiple": "Selección multiple",
            "display_list": "Ver en lista",
            "display_grid": "Ver en grid (deshabilitado)",
            "print": "Imprimir",
            "print_pdf": "Imprimir PDF",
            "print_csv": "Imprimir CSV",
            "customer_sales_report": "Reporte por cliente",
            "email": "Enviar por Correo",
            "delete": "Eliminar",
            "add": "Agregar",
            "addDetail": "Agregar Detalle",
            "edit": "Editar",
            "save": "Guardar",
            "accept": "Aceptar",
            "cancel": "Cancelar",
            "view": "Ver",
            "import": "Importar",
            "registered_on": "Registrado desde",
            "order_by": "Ordenado por",
            "options": "Más opciones",
            "notifications": "Notificaciones",
            "messages": "Mensajes",
            "no_notifications": "No tienes notificaciones",
            "no_messages": "No tienes mensajes",
            "see_all": "Ver",
            "exit": "Salir",
            "back": "Volver",
            "invoice": "Factura",
            "invoices": "Facturas Y Pagos",
            "see_loss_reason": "Ver razon de perdida",
            "cancelled": "Cancelado",
            "sold": "Vendido",
            "invoiced": "Facturado",
            "finished": "Terminada",
            "finish": "terminar",
            "paid": "Pagado",
            "pending": "Pendiente",
            "approved": "Aprobado",
            "received": "Recibido",
            "send": "Enviado",
            "partiallypaid": "Pago parcial",
            "partiallyinvoiced": "Facturado parc.",
            "lossed": "Perdida",
            "active": "Activa",
            "in_progress": "En Proceso",
            "attended": "Antendido",
            "action_sold": "Pagar",
            "action_invoiced": "Facturar",
            "action_uninvoiced": "Vendido",
            "action_paid": "Pagar",
            "action_unpaid": "Facturado",
            "action_approved": "Aprobar",
            "action_received": "Recibir",
            "action_send": "Enviar",
            "action_active": "Activar",
            "action_inactive": "Inactivar",
            "add_signature": "Agregar firma",
            "digits_card": "Terminación de la tarjeta",
            "order_customer_placeholder": "Ingrese los últimos 4 dígitos",
            "resumen": "Resumen de recepciones",
            "resumen_supplier_shipping": "Resumen de Envio de proveedor",
            "sent": "Enviado con éxito",
            "payment": "Pago agregado",
            "sent_individual": "Realizar envío",
            "recived": "Recibir",
            "supplier_shipping": "Envio de proveedor",
            "invoicePayment ": "Pago",
            "shipment": "envio de la paquetería: ",
            "shippments": "Envios de proveedor",
            "details": "Detalle",
            "sendings": "Envios",
            "sendings_complete": "Envio Completo",
            "sendings_incomplete": "Envio Incompleto",
            "reception_complete": "Completo",
            "reception_incomplete": "Incompleto",
            "sendings_receptions": "Recepciones",
            "sale-import": "Importacion",
            "sale-expense": "Otro gasto",
            "sale-imports": "Importaciones",
            "sale-expenses": "Otros gastos",
            "edit_files": "Editar Archivos",
            "propose": "Proponer",
            "reject": "Rechazar",
            "close": "Cerrar",
            "see_note": "Ver nota",
            "feedback": "Comentarios",
            "assign": "Asignar",
            "customer_address": "Direccion del cliente",
            "customer_contacts": "Direccion del cliente",
            "prospecting": "Prospección",
            "prospectings": "Prospectos",
            "prospectings_inactived": "Inactividad de Prospectos en 15 días",
            "contacted_from": "Sin contacto desde:",
            "lead": "Lead",
            "loss": "Perdida",
            "supplier_quotations": "Cotizaciones proveedor",
            "delivery_on_time": "A tiempo",
            "delivery_early_end": "A punto de vencer",
            "delivery_over_time": "Vencida",
            "delivery_completed": "Completada",
            "partial_delivery": "Parcialmente entregada",
            "other": "Otro",
            "resume": "Reanudar"
        },
        "supplier_shippment": {
            "parcel": "Paqueteria",
            "guide_number": "Número de Guía",
            "arrival_date": "Fecha de llegada",
            "product": "Producto",
            "quantity_ordered": "Cantidad Ordenada \/ Cantidad por recibir",
            "quantity_sent": "Cantidad enviada",
            "shipping_date": "Fecha del envio",
            "created_by": "Elaborado por:",
            "actions": "Acciones",
            "edit": "Editar envio de Proveedor",
            "purchase_order": "Orden De Compra",
            "supplier": "Proveedor",
            "quantity_received": "Cantidad Recibida",
            "preview": "Envio de proveedor"
        },
        "suppliers": {
            "add": "Agregar proveedor",
            "edit": "Editar proveedor",
            "delete": "Eliminar proveedor",
            "not_find": "No se puede encontrar un proveedor con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del proveedor",
            "contact": "Contacto",
            "contact_placeholder": "Ingresa el contacto del proveedor",
            "address": "Address",
            "address_placeholder": "Ingresa la dirección del proveedor",
            "has_rfc": "Este proveedor es americano?",
            "rfc": "RFC",
            "rfc_placeholder": "Ingresa el RFC del proveedor",
            "phone": "Teléfono",
            "phone_placeholder": "Ingresa el número de teléfono del proveedor",
            "country": "País",
            "country_placeholder": "Ingresa el nombre del proveedor",
            "billing_address_id": "Dirección de Envio",
            "billing_address_id_placeholder": "Ingresa la dirección de facturación del proveedor",
            "zipcode": "Código postal",
            "zipcode_placeholder": "Ingresa el código postal",
            "direct_shipping": "Envia a Cliente",
            "direct_shipping_placeholder": "Selecciona si envia a cliente",
            "created_at": "Creado en",
            "report_title": "Reporte de Proveedores"
        },
        "tasks": {
            "add": "Nueva Tarea",
            "edit": "Edit task",
            "delete": "Delete task",
            "not_find": "Can not find task with this code.",
            "tasks": "Tareas",
            "id": "Id",
            "assign_by": "RESPONSABLE",
            "folio": "Folio",
            "type": "Tipo",
            "title": "Titulo Tarea",
            "start_date": "Fecha de inicio",
            "end_date": "Fecha de Vencimiento",
            "name": "Tarea",
            "name_placeholder": "Nombre de la Tarea",
            "desc_placeholder": "Agrega su descripcion",
            "export": "Exportar",
            "user_placeholder": "Un usuario",
            "status": "Status",
            "desc": "Descripcion",
            "desc_task": "Descripcion de tarea",
            "users": "Responsable",
            "comments": "Comentarios",
            "sale": "Venta",
            "files": "Archivos adjuntos",
            "created_by": "Creada por",
            "created_at": "Created at",
            "report_title": "Tasks Report",
            "sell": "Venta",
            "client": "Cliente",
            "quotation": "Cotizacion",
            "seller": "Vendedor",
            "expire": "Vencimiento",
            "oc": "Orden de Compras",
            "inProgressStatus": "Tarea Resumida",
            "finishedStatus": "Tarea Finalizada",
            "task_updated": "Tarea Actualizada",
            "task_created": "Tarea Creada"
        },
        "tasks_modal": {
            "title": "Titulo de tarea",
            "desc_task": "Descripcion de tarea",
            "start_date": "Fecha de inicio",
            "end_date": "Fecha de vencimiento",
            "type": "Tipo",
            "folio": "Folio",
            "assign_to": "Asignar a:",
            "assign_to_another": "Añadir",
            "create": "Crear tarea",
            "attatchment": "Adjuntar archivo",
            "add_resp": "añadir otro asignado"
        },
        "units_measurement": {
            "add": "Agregar unidad de medida",
            "edit": "Editar unidad de medida",
            "delete": "Eliminar unidad de medida",
            "not_find": "No se puede encontrar una unidad de medida con este código.",
            "id": "Id",
            "code": "Código",
            "code_placeholder": "Ingresa el código de la unidad de medida",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre de la unidad de medida",
            "symbol": "Simbolo",
            "symbol_placeholder": "Ingresa el simbolo de la unidad de medida",
            "created_at": "Creado en",
            "report_title": "Reporte de Unidades de Medida"
        },
        "users": {
            "add": "Agregar usuario",
            "edit": "Editar usuario",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un usuario con este código.",
            "actived_error": "Usuario ya activo",
            "inactived_error": "Usuario ya inactivo",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del usuario",
            "email": "Correo",
            "email_placeholder": "Ingresa el correo electrónico del usuario",
            "password": "Contraseña",
            "password_placeholder": "Ingresa la contraseña del usuario",
            "confirm_password": "Confirma Contraseña",
            "confirm_password_placeholder": "Confirma la contraseña del usuario",
            "smtp_password": "Contraseña SMTP",
            "smtp_password_placeholder": "Ingresa la contraseña del correo del usuario",
            "role": "Role",
            "role_placeholder": "Ingresa el rol del usuario",
            "status": "Estatus",
            "leave_empty": "Dejar vacío para mantener la contraseña actual.",
            "created_at": "Creado en",
            "report_title": "Reporte de Usuarios",
            "Admin": "Administrador",
            "Seller": "Ventas",
            "Procurement": "Compras",
            "Storekeeper": "Almacen"
        },
        "validation": {
            "accepted": "El campo {attribute} debe ser aceptado.",
            "active_url": "El campo {attribute} no es una URL válida.",
            "after": "El campo {attribute} debe ser una fecha después a {date}.",
            "after_or_equal": "El campo {attribute} debe ser una fecha posterior o igual a {date}.",
            "alpha": "El campo {attribute} solo puede contener letras.",
            "alpha_dash": "El campo {attribute} solo puede contener letras, números, guiones y guiones bajos.",
            "alpha_num": "El campo {attribute} solo puede contener letras y números.",
            "array": "El campo {attribute} debe ser una matriz.",
            "before": "El campo {attribute} debe ser una fecha antes de {date}.",
            "before_or_equal": "El campo {attribute} debe ser una fecha antes o igual a {date}.",
            "between": {
                "numeric": "El {attribute} debe estar entre {min} y {max}.",
                "file": "El {attribute} debe estar entre {min} y {max} kilobytes.",
                "string": "El {attribute} debe estar entre {min} y {max} caracteres.",
                "array": "El {attribute} debe estar entre {min} y {max} artículos."
            },
            "boolean": "El campo {attribute} debe ser verdadero o falso.",
            "confirmed": "El {attribute} la confirmación no coincide.",
            "date": "La {attribute} no es una fecha valida.",
            "date_format": "La {attribute} no coincide con el formato {format}.",
            "different": "El {attribute} y {other} deben ser diferentes.",
            "digits": "El {attribute} deben ser {digits} dígitos.",
            "digits_between": "El {attribute} debe estar entre {min} y {max} dígitos.",
            "dimensions": "El {attribute} tiene dimensiones de imagen inválidas.",
            "distinct": "El {attribute} campo tiene un valor duplicado.",
            "email": "El campo {attribute} debe ser una dirección de correo electrónico válida.",
            "exists": "El seleccionado {attribute} no es válido.",
            "file": "El {attribute} debe ser un archivo.",
            "filled": "El {attribute} campo debe tener un valor.",
            "gt": {
                "numeric": "El {attribute} debe ser mayor que {value}.",
                "file": "El {attribute} debe ser mayor que {value} kilobytes.",
                "string": "El {attribute} debe ser mayor que {value} caracteres.",
                "array": "El {attribute} debe tener más que {value} artículos."
            },
            "gte": {
                "numeric": "El {attribute} debe ser mayor o igual que {value}.",
                "file": "El {attribute} debe ser mayor o igual que {value} kilobytes.",
                "string": "El {attribute} debe ser mayor o igual que {value} caracteres.",
                "array": "El {attribute} debe tener {value} artículos o más."
            },
            "image": "La {attribute} debe ser una imagen.",
            "in": "El seleccionado {attribute} no es válido.",
            "in_array": "El {attribute} campo no existe en {other}.",
            "integer": "El {attribute} debe ser un entero.",
            "ip": "La {attribute} debe ser una dirección IP válida.",
            "ipv4": "La {attribute} debe ser una dirección IPv4 válida.",
            "ipv6": "La {attribute} debe ser una dirección IPv6 válida.",
            "json": "La {attribute} debe ser una cadena JSON válida.",
            "lt": {
                "numeric": "El {attribute} debe ser menor que {value}.",
                "file": "El {attribute} debe ser menor que {value} kilobytes.",
                "string": "El {attribute} debe ser menor que {value} caracteres.",
                "array": "El {attribute} debe tener menos que {value} artículos."
            },
            "lte": {
                "numeric": "El {attribute} debe ser menor o igual {value}.",
                "file": "El {attribute} debe ser menor o igual {value} kilobytes.",
                "string": "El {attribute} debe ser menor o igual {value} caracteres.",
                "array": "El {attribute} no debe tener más de {value} artículos."
            },
            "max": {
                "numeric": "El {attribute} no puede ser mayor que {max}.",
                "file": "El {attribute} no puede ser mayor que {max} kilobytes.",
                "string": "El {attribute} no puede ser mayor que {max} caracteres.",
                "array": "El {attribute} no puede tener más de {max} artículos."
            },
            "mimes": "El {attribute} must be a file of type: {values}.",
            "mimetypes": "Los {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "El campo {attribute} debe ser al menos de {min}.",
                "file": "El campo {attribute} debe ser al menos de {min} kilobytes.",
                "string": "El campo {attribute} debe ser al menos de {min} caracteres.",
                "array": "El campo {attribute} debe tener al menos {min} artículos."
            },
            "not_in": "El seleccionado {attribute} no es válido.",
            "not_regex": "El {attribute} formato no es válido.",
            "numeric": "El campo {attribute} tiene que ser un número.",
            "present": "El campo {attribute} debe estar presente.",
            "regex": "El campo {attribute} formato no es válido.",
            "required": "El campo {attribute} es requerido.",
            "required_if": "El campo {attribute} es requerido cuando {other} es {value}.",
            "required_unless": "El campo {attribute} es requerido a menos que {other} es en {values}.",
            "required_with": "El campo {attribute} es requerido cuando {values} esta presente.",
            "required_with_all": "El campo {attribute} es requerido cuando {values} esta presente.",
            "required_without": "El campo {attribute} es requerido cuando {values} no esta presente.",
            "required_without_all": "El campo {attribute} es requerido cuando ninguno de {values} estan presentes.",
            "same": "El campo {attribute} debe coincidir con {other}.",
            "size": {
                "numeric": "El {attribute} debe ser {size}.",
                "file": "El {attribute} debe ser {size} kilobytes.",
                "string": "El {attribute} debe ser {size} caracteres.",
                "array": "El {attribute} debe contener {size} artículos."
            },
            "string": "El {attribute} debe ser un texto.",
            "timezone": "El {attribute} debe ser una zona válida.",
            "unique": "El {attribute} ya se ha tomado.",
            "uploaded": "El {attribute} no se pudo cargar.",
            "url": "El {attribute} formato no válido.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "verification": {
            "title": "Verifica tu correo electrónico",
            "check_email": "Necesitamos verificar tu dirección de email",
            "check_email_label": "Consulta el correo electrónico para finalizar el registro. Te hemos enviado un enlace de registro a la dirección:",
            "resend_email": "¿No has recibido el enlace de registro? Volver a enviarlo",
            "resend_succesfully": "Reenviado satisfactoriamente",
            "reset_email": "Cambiar dirección de correo electrónico"
        },
        "welcome": {
            "subject": "Bienvenido a Controlla",
            "line_1": "Bienvenido.",
            "action": "Pruébalo ahora"
        }
    },
    "en": {
        "addresses": {
            "add": "Add address",
            "edit": "Edit address",
            "delete": "Delete address",
            "not_find": "Can not find an address with this code.",
            "id": "Id",
            "address": "Address",
            "address_placeholder": "Enter address",
            "city": "City",
            "city_placeholder": "Enter the addressee's city",
            "state": "State",
            "state_placeholder": "Enter the addressee's state",
            "country": "Country",
            "country_placeholder": "Enter the addressee's country",
            "bill_address": "Billing Address",
            "bill_address_placeholder": "Enter the billing address",
            "delivery_address": "Delivery Address",
            "delivery_address_placeholder": "Enter the delivery address",
            "zip_code": "Zip Code",
            "zip_code_placeholder": "Enter the addressee's zip code",
            "created_at": "Created at",
            "report_title": "Addresses Report"
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in :seconds seconds."
        },
        "comments": {
            "add": "Add comment",
            "edit": "Edit comment",
            "delete": "Delete comment",
            "not_find": "Can not find comment with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the comment's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Comments Report"
        },
        "currencies": {
            "add": "Add currency",
            "edit": "Edit currency",
            "delete": "Delete currency",
            "not_find": "Can not find a currency with this code.",
            "id": "Id",
            "name": "Currency",
            "name_placeholder": "Enter the currency",
            "code": "Code",
            "code_placeholder": "Enter the currency code",
            "created_at": "Created at",
            "report_title": "Currencies Report"
        },
        "customer_addresses": {
            "add": "Add customerAddress",
            "edit": "Edit customerAddress",
            "delete": "Delete customerAddress",
            "not_find": "Can not find customerAddress with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the customerAddress's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "CustomerAddresses Report"
        },
        "customer_contacts": {
            "add": "Add customerContact",
            "edit": "Edit customerContact",
            "delete": "Delete customerContact",
            "not_find": "Can not find customerContact with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the customerContact's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "CustomerContacts Report"
        },
        "customers": {
            "add": "Add customer",
            "edit": "Edit customer",
            "delete": "Delete customer",
            "not_find": "Can not find a client with this code.",
            "id": "Id",
            "customer": "Name",
            "totalCM": "Total sales per month",
            "totalCY": "Total sales per year",
            "totalAM": "Total amount of sales per month",
            "totalAY": "Total amount of sales per year",
            "tradename": "Trade Name",
            "tradename_placeholder": "Enter the customer's trade name",
            "phone": "Phone Number",
            "phone_placeholder": "Enter the customer's phone number",
            "contact": "Contact",
            "contact_placeholder": "Enter the customer's contact",
            "address": "Address",
            "address_placeholder": "Enter the customer's address",
            "city": "City",
            "city_placeholder": "Enter the customer's city",
            "state": "State",
            "state_placeholder": "Enter the customer's state",
            "country": "Country",
            "country_placeholder": "Enter the customer's country",
            "zip_code": "zip_code",
            "zip_code_placeholder": "Enter the customer's zip_code",
            "email": "Email",
            "email_placeholder": "Enter the customer's email",
            "rfc": "RFC",
            "rfc_placeholder": "Enter the customer's RFC",
            "mining_group_id": "Mining Group",
            "mining_group_id_placeholder": "Enter the customer's mining group",
            "created_at": "Created at",
            "report_title": "Customers Report",
            "createdBy": "Created By",
            "contact_status": "Contact Status",
            "contact_status_select": "Enter the contact status",
            "mention": "How do you know us?"
        },
        "email": {
            "email": "Email",
            "email_placeholder": "Enter the email address",
            "subject": "Subject",
            "subject_placeholder": "Enter the subject",
            "body": "Message",
            "body_placeholder": "Enter the message"
        },
        "errors": {
            "fatal_error": "A fatal error occurred, please contact us.",
            "generic_error": "An error occurred, please try again.",
            "unauthorized": "Unauthorized.",
            "forbidden": "Forbidden.",
            "connection_error": "Connection error",
            "action_unauthorized": "This action is unauthorized."
        },
        "feedback": {
            "rate": "What do you think of this experience?",
            "comment": "Tell us how was your experience?",
            "contact_me": "Controlla can contact me about my feedback."
        },
        "front": {
            "added_successfully": "It has been added successfully.",
            "updated_successfully": "It has been updated successfully.",
            "deleted_successfully": "It has been deleted successfully.",
            "imported_successfully": "It has been imported successfully.",
            "send_successfully": "It has been send successfully.",
            "delete_modal": "Delete",
            "delete_confirmation": "Are you sure you want to delete the :model :attribute?",
            "delete_confirmation2": "Are you sure you want to delete :model :attribute?",
            "action_confirmation": "Are you sure you want to :action this :model?",
            "action_confirmation2": "Are you sure you want to :action this :model?",
            "import_modal": "Import :model from CSV or Excel file"
        },
        "login": {
            "email": "Email",
            "password": "Password",
            "keep_connected": "Keep connected",
            "forgot_password": "Forgot password",
            "login": "Login",
            "logout": "Logout",
            "reset_password": "Reset password",
            "send_reset_link": "Send the reset link",
            "password_confirmation": "Password confirmation",
            "still_having_trouble": "Still having trouble logging in?",
            "havent_account": "Don't have a account?",
            "back_login": "Back to login",
            "register": "Create account",
            "welcome": "Welcome",
            "description": "Description app"
        },
        "mining_groups": {
            "add": "Add mining group",
            "edit": "Edit mining group",
            "delete": "Delete mining group",
            "not_find": "Can not find a mining group with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the mining group's name",
            "razon_social": "Business Name",
            "razon_social_placeholder": "Enter the mining group's business name",
            "delivery_address": "Delivery Address",
            "delivery_address_placeholder": "Enter the mining group's delivery address",
            "comments": "Comments",
            "comments_placeholder": "Enter the mining group's comments",
            "created_at": "Created at",
            "report_title": "Mining Groups Report"
        },
        "notifications": {
            "empty_title": "No notifications at this time",
            "empty_msg": "When your team starts doing things, we will show the notifications here.",
            "add_new_user": "New User!",
            "add_new_user_message": "has added a new user"
        },
        "pagination": {
            "previous": "« Previous",
            "next": "Next »"
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address.",
            "cant_login": "Can't you login?",
            "very_weak": "Very weak",
            "weak": "Weak",
            "good": "Good",
            "strong": "Strong",
            "very_strong": "Very strong"
        },
        "payment_methods": {
            "add": "Add payment method",
            "edit": "Edit payment method",
            "delete": "Delete payment method",
            "not_find": "Can not find a payment method with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the payment method's name",
            "created_at": "Created at",
            "report_title": "Payment Methods Report"
        },
        "product_categories": {
            "add": "Add productCategory",
            "edit": "Edit productCategory",
            "delete": "Delete productCategory",
            "not_find": "Can not find productCategory with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the productCategory's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "ProductCategories Report"
        },
        "products": {
            "add": "Add product",
            "edit": "Edit product",
            "delete": "Delete product",
            "not_find": "Can not find a product with this code.",
            "description": "Description",
            "id": "Id",
            "sku": "Stock Keeping Unit",
            "sku_placeholder": "Enter the product's stuck keeping unit",
            "name": "Name",
            "name_placeholder": "Enter the product's phone number",
            "number_part": "Part Number",
            "number_part_placeholder": "Enter the product's part number",
            "price": "Price",
            "price_placeholder": "Enter the product's price",
            "unit_measurement_id": "Measurement Unit",
            "unit_measurement_id_placeholder": "Enter the product's measurement unit",
            "currency_id": "Currency",
            "currency_id_placeholder": "Enter the product's currency",
            "created_at": "Created at",
            "report_title": "Products Report"
        },
        "purchase_orders": {
            "add": "Add purchase order",
            "edit": "Edit purchase order",
            "delete": "Delete purchase order",
            "not_find": "Can not find a purchase order with this code.",
            "approved": "The purchase order is approved",
            "cancelled": "The purchase order is cancelled",
            "paid": "The purchase order is paid",
            "pending": "The purchase order is pending",
            "send": "The purchase order is sent",
            "cus": "Customer",
            "id": "Id",
            "folio": "Folio",
            "folio_placeholder": "Enter the purchase order's folio",
            "delivery_time": "Delivery Time",
            "delivery_time_placeholder": "Enter the purchase order's delivery time",
            "subtotal": "Subtotal",
            "subtotal_placeholder": "Enter the purchase order's subtotal",
            "total": "Total",
            "total_placeholder": "Enter the purchase order's total",
            "fletes": "Shipping",
            "fletes_placeholder": "Enter the purchase order's shipping",
            "status": "Status",
            "status_placeholder": "Enter the purchase order's status",
            "shipping_address_id": "Shipping Address",
            "shipping_address_id_placeholder": "Enter the purchase order's shippimg address",
            "customer_id": "Customer",
            "customer_id_placeholder": "Enter the purchase order's customer",
            "supplier_id": "Supplier",
            "supplier_id_placeholder": "Enter the purchase order's supplier",
            "billing_address_id": "Billing Address",
            "billing_address_id_placeholder": "Enter the purchase order's billing address",
            "zipcode": "Zip code",
            "zipcode_placeholder": "Enter zip code",
            "authorization_by": "Authorization by",
            "authorization_by_placeholder": "Enter the purchase order's authorization user",
            "currency_id": "Currency",
            "currency_id_placeholder": "Enter the purchase order's currency",
            "quotation_id": "Quotation",
            "quotation_id_placeholder": "Enter the purchase order's quotation",
            "cancelled_date": "Cancellation Date",
            "cancelled_date_placeholder": "Enter the purchase order's cancellation date",
            "authorization_date": "Authorization Date",
            "authorization_date_placeholder": "Enter the purchase order's authorization date",
            "created_by_id": "Created by",
            "created_by_id_placeholder": "Enter the purchase order's user",
            "cancelled_by_id": "Cancelled By",
            "cancelled_by_id_placeholder": "Enter the purchase order's cancellation user",
            "authorization_by_id": "Authorization By",
            "authorization_by_id_placeholder": "Enter the purchase order's authorization user",
            "total_mn": "Total MN",
            "total_mn_placeholder": "Enter the purchase order's total",
            "exchange_rate": "Exchange Rate",
            "exchange_rate_placeholder": "Enter the purchase order's exchange rate",
            "tax": "Tax",
            "tax_placeholder": "Enter the purchase order's tax",
            "created_at": "Created at",
            "report_title": "Purchase Orders Report",
            "email_sent": "Send",
            "guide_number": "Número de guía",
            "parcel": "Paquetería",
            "date_send": "Fecha de envío",
            "arrival_date": "Fecha de llegada",
            "partiallyreceived": "Part. recived"
        },
        "purchase_orders_detail": {
            "add": "Add purchase orders detail",
            "edit": "Edit purchase orders detail",
            "delete": "Delete purchase orders detail",
            "not_find": "Can not find a purchase orders detail with this code.",
            "id": "Id",
            "quantity": "Quantity",
            "quantity_placeholder": "Enter the purchase orders detail's quantity",
            "unit_price": "Unit Price",
            "unit_price_placeholder": "Enter the purchase orders detail's unit price",
            "total": "Total",
            "total_placeholder": "Enter the purchase orders detail's total",
            "product_id": "Product",
            "product_id_placeholder": "Enter the purchase orders detail's product",
            "purchase_order_id": "Purchase Order",
            "purchase_order_id_placeholder": "Enter the purchase orders detail's purchase order",
            "quotation_id": "Quotation",
            "quotation_id_placeholder": "Enter the purchase orders detail's quotation",
            "created_at": "Created at",
            "report_title": "Purchase Orders Details Report",
            "receptions": "Receptions",
            "receptions_select": "Select a product to receive",
            "received_on": "Received on",
            "receptions_ordered": "Received amount",
            "ordered_quantity": "Ordered quantityt",
            "date_ordered": "Date of quantity received",
            "send": "Send product",
            "sent": "Sent",
            "add_send": "Add shipping",
            "send_quantity": "Send receipt",
            "cantsend_quantity": "Amount to send",
            "send_placeholder": "Enter the amount to send",
            "guide_number": "Guide number",
            "guide_number_placeholder": "Enter the guide number",
            "parcel": "Parcel",
            "parcel_placeholder": "Enter parcel name",
            "date_send": "Shipping date",
            "date_send_placeholder": "Delivery dateEnter shipping date",
            "arrival_date": "Enter arrival date",
            "arrival_date_placeholder": "Delivery dateEnter arrival date",
            "invoice_number": "Invoice",
            "date": "Date",
            "amount": "Amount",
            "status": "Status",
            "expire": "Expire",
            "supplier_shipping": "Supplier shipping",
            "reception_orders_sent": "Received  \/ Ordered",
            "supplier": "Supplier",
            "oc": "Purchase order",
            "supplier_shipping_detail": "Supplier shipping details",
            "oc_detail": "Purchase order details"
        },
        "quotations": {
            "add": "Add quotation",
            "edit": "Edit quotation",
            "delete": "Delete quotation",
            "not_find": "Can not find a quotation with this code.",
            "approved": "The quotation is approved",
            "cancelled": "The quotation is cancelled",
            "paid": "The quotation is paid",
            "action_sold": "sell",
            "action_cancelled": "cancel",
            "action_pending": "discard",
            "sold": "The quotation is sold",
            "id": "Id",
            "folio": "Folio Number",
            "folio_placeholder": "Enter the quotation's folio number",
            "type_utility": "Utility Type",
            "type_utility_placeholder": "Enter the quotation's utility type",
            "delivery_time": "Delivery Time",
            "delivery_time_placeholder": "Enter the quotation's delivery time",
            "flete": "Shipping Cost",
            "flete_placeholder": "Enter the quotation's shipping cost",
            "discount": "Discount",
            "discount_utility_placeholder": "Enter the quotation's discount",
            "total": "Total",
            "total_placeholder": "Enter the quotation's total",
            "subtotal": "Subtotal",
            "subtotal_placeholder": "Enter the quotation's subtotal",
            "tax_rate": "Tax Rate",
            "tax_rate_placeholder": "Enter the quotation's tax rate",
            "sales_tax": "Sales Tax",
            "sales_tax_placeholder": "Enter the quotation's sales tax",
            "utility": "Utility",
            "utility_placeholder": "Enter the quotation's utility",
            "comments": "Comments",
            "comments_placeholder": "Enter the quotation's comments",
            "exchange_rate": "Exchange Rate",
            "exchange_rate_placeholder": "Enter the quotation's exchange rate",
            "status": "Status",
            "status_placeholder": "Enter the quotation's status",
            "currency_id": "Currency",
            "currency_id_placeholder": "Enter the quotation's currency",
            "customer_id": "Customer",
            "customer_id_placeholder": "Enter the quotation's customer",
            "customer": "Customer",
            "customer_placeholder": "Enter the quotation's customer",
            "seller_id": "Seller",
            "seller_id_placeholder": "Enter the quotation's seller",
            "cancelled_date": "Cancellation Date",
            "cancelled_date_placeholder": "Enter the quotation's cancellation date",
            "authorization_date": "Authorization Date",
            "authorization_date_placeholder": "Enter the quotation's authorization date",
            "created_by_id": "Created By",
            "created_by_id_placeholder": "Enter the quotation's creation user",
            "cancelled_by_id": "Cancelled By",
            "cancelled_by_id_placeholder": "Enter the quotation's cancellation user",
            "authorization_by_id": "Authorization By",
            "authorization_by_id_placeholder": "Enter the quotation's authorization user",
            "total_mn": "Total MN",
            "total_mn_placeholder": "Enter the quotation's total",
            "order_customer": "Customer PO",
            "order_customer_placeholder": "Enter the quotation's number",
            "delivery_address": "Delivery Address",
            "delivery_address_placeholder": "Enter the quotation's delivery address",
            "printing_date": "PRINTING DATE",
            "payment_conditions": "Payment Conditions",
            "payment_conditions_placeholder": "Enter the quotation's payment conditions",
            "general_delivery_time_flag": "General Delivery Time",
            "created_at": "Created at",
            "report_title": "Qutations Report",
            "pending": "Pending"
        },
        "quotations_detail": {
            "add": "Add quotation detail",
            "edit": "Edit quotation detail",
            "delete": "Delete quotation detail",
            "not_find": "Can not find a quotation detail with this code.",
            "id": "Id",
            "quantity": "Quantity",
            "quantity_placeholder": "Enter the quotation detail's quantity",
            "unit_price": "Unit Price",
            "unit_price_placeholder": "Enter the quotation detail's unit price",
            "price": "Price",
            "price_placeholder": "Enter the quotation detail's price",
            "total": "Total",
            "total_placeholder": "Enter the quotation detail's total",
            "flete": "Shipping",
            "flete_placeholder": "Enter the quotation detail's shipping",
            "fletes": "Shipping",
            "fletes_placeholder": "Enter the quotation detail's shipping",
            "utility": "Utility %",
            "utility_placeholder": "Enter the quotation detail's utility %",
            "utility_amount": "Utility $",
            "utility_amount_placeholder": "Enter the quotation detail's utility $",
            "subtotal": "Subtotal",
            "subtotal_placeholder": "Enter the quotation detail's subtotal",
            "supplier_id": "Supplier",
            "supplier_id_placeholder": "Enter the quotation detail's supplier",
            "quotation_id": "Quotation",
            "quotation_id_placeholder": "Enter the quotation detail's quotation",
            "product_id": "Product",
            "product_id_placeholder": "Enter the quotation detail's product",
            "pu": "U P",
            "unit_cost": "U C",
            "utility_sub": "Sub utility",
            "individual_delivery_time": "Delivery Time",
            "created_at": "Created at",
            "report_title": "Quotation Details Report"
        },
        "receptions": {
            "product": "Product",
            "quantity": "Quantity available to receive",
            "to_recived": "Receive:",
            "actions": "Actions"
        },
        "register": {
            "title": "Sign up to get your account",
            "email": "Email",
            "name": "Username",
            "password": "Password",
            "register": "Create account",
            "message": "By registering, confirm that you have read and accepted our  <a href=\"\/login\"> Terms of use <\/a> and our <a href=\"\/login\"> Privacy policy <\/a>.",
            "back_login": "Already have an Controlla account? Log in",
            "very_weak": "Very weak",
            "weak": "Weak",
            "good": "Good",
            "strong": "Strong",
            "very_strong": "Very strong"
        },
        "reset": {
            "subject": "Reset your Controlla Password",
            "line_1": "You are receiving this email because we received a password reset request for your account.",
            "action": "Reset Password",
            "line_2": "This password reset link will expire in :count minutes.",
            "line_3": "If you did not request a password reset, no further action is required."
        },
        "sale_tracings": {
            "add": "Add saleTracing",
            "edit": "Edit saleTracing",
            "delete": "Delete saleTracing",
            "not_find": "Can not find saleTracing with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the saleTracing's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "SaleTracings Report"
        },
        "sales": {
            "add": "Add sale",
            "edit": "Edit sale",
            "delete": "Delete sale",
            "not_find": "Can not find a sale with this code.",
            "invoiced": "Invoiced",
            "description_invoiced": "Invoice details",
            "paid": "Paid",
            "invoice": "Incoice",
            "add_invoices": "Add incoices",
            "add_invoice_payment": "Add incoices and payments",
            "payment": "Payment",
            "id": "Id",
            "folio": "Folio",
            "folio_placeholder": "Enter the sale's folio",
            "delivery_time": "Delivery Time",
            "delivery_time_placeholder": "Enter the sale's delivery time",
            "total": "Total",
            "total_placeholder": "Enter the sale's total",
            "amount_invoice": "amount",
            "amount_invoice_placeholder": "Enter the total of the invoice",
            "status": "Status",
            "status_placeholder": "Enter the sale's status",
            "currency_id": "Currency",
            "currency_id_placeholder": "Enter the sale's currency",
            "currency_invoice_placeholder": "Enter the sale's invoice",
            "customer_id": "Customer",
            "customer_id_placeholder": "Enter the sale's customer",
            "seller_id": "Seller",
            "seller_id_placeholder": "Enter the sale's seller",
            "quotation_id": "Quotation",
            "quotation_id_placeholder": "Enter the sale's quotation",
            "payment_method_id": "Payment Method",
            "payment_method_id_placeholder": "Enter the sale's payment method",
            "add_payment": "Add payment",
            "cancelled_date": "Cancellation Date",
            "cancelled_date_placeholder": "Enter the sale's cancellation date",
            "authorization_date": "Authorization Date",
            "authorization_date_placeholder": "Enter the sale's authorization date",
            "date": "Date",
            "date_placeholder": "Enter the invoice's date",
            "created_by_id": "Created By",
            "created_by_id_placeholder": "Enter the sale's creation user",
            "cancelled_by_id": "Cancelled By",
            "cancelled_by_id_placeholder": "Enter the sale's cancellation user",
            "authorization_by_id": "Authorization By",
            "authorization_by_id_placeholder": "Enter the sale's authorization user",
            "total_mn": "Total MN",
            "total_mn_placeholder": "Enter the sale's total",
            "exchange_rate": "Exchange Rate",
            "exchange_rate_placeholder": "Enter the sale's exchange rate",
            "remaining": "Remaining",
            "remaining_placeholder": "Enter the remainder of the sale",
            "digits_card": "Card termination",
            "digits_card_placeholder": "Enter the last 4 digits",
            "created_at": "Created at",
            "report_title": "Sales Report",
            "no": "No"
        },
        "sales_detail": {
            "add": "Add sales detail",
            "edit": "Edit sales detail",
            "delete": "Delete sales detail",
            "not_find": "Can not find a sales detail with this code.",
            "id": "Id",
            "quantity": "Quantity",
            "quantity_placeholder": "Enter the sales detail's quantity",
            "unit_price": "Unit Price",
            "unit_price_placeholder": "Enter the sales detail's unit price",
            "total": "Total",
            "total_placeholder": "Enter the sales detail's total",
            "utility": "Utility",
            "utility_placeholder": "Enter the sales detail's utility",
            "created_at": "Created at",
            "report_title": "Sales Details Report"
        },
        "sending_receptions": {
            "actions": "Actions",
            "product": "Product",
            "quantity_ordered": "Ordered \/ Received \/ Sent",
            "quantity_to_send": "Quantity to send",
            "parcel": "Parcel",
            "guide_nubmer": "Guide Number",
            "sending_detail": "Amount Sent"
        },
        "strings": {
            "dashboard": "Dashboard",
            "overview": "Overview",
            "user": "User",
            "users": "Users",
            "customer": "Customer",
            "customers": "Customers",
            "quotation": "Quotation",
            "quotations": "Quotations",
            "quotation_detail": "Quotation Detail",
            "quotation_details": "Quotation Details",
            "purchase_order": "Purchase Order",
            "oc_number": "P.O. #",
            "purchase_orders": "Purchase Orders",
            "sale": "Sale",
            "sales": "Sale",
            "supplier": "Supplier",
            "suppliers": "Suppliers",
            "product": "Product",
            "products": "Products",
            "mining_group": "Mining Group",
            "mining_groups": "Mining Groups",
            "addpayments": "Payment",
            "payments": "Payment",
            "add_amount": "Enter the amount",
            "amount": "quantity",
            "payment_method": "Payment method",
            "method": "Payment method",
            "date": "Fecha",
            "payment_date": "Fecha",
            "description": "An Overview of your :attribute",
            "search": "Search :attribute by:columns or :column",
            "filters": "Filters",
            "clear": "Clear",
            "apply": "Apply",
            "select_date": "Select a date",
            "multiple": "Multiple",
            "display_list": "Display list",
            "display_grid": "Display grid (enabled)",
            "print": "Print",
            "email": "Send Email",
            "delete": "Delete",
            "add": "Add",
            "addDetail": "Add Detail",
            "edit": "Edit",
            "save": "Save",
            "accept": "Accept",
            "cancel": "Cancel",
            "view": "View",
            "import": "Import",
            "export": "Export",
            "registered_on": "Registered on",
            "order_by": "Order by",
            "options": "More options",
            "notifications": "Notifications",
            "messages": "Messages",
            "no_notifications": "No notifications",
            "no_messages": "No messages",
            "see_all": "See all",
            "exit": "Exit",
            "back": "Back",
            "invoice": "Invoice",
            "feedback": "Feedback",
            "give_feedback": "Give feedback",
            "shortcuts": "Shortcuts",
            "close_modal": "Close modal",
            "create": "Create resource",
            "view_selected": "View selected",
            "edit_selected": "Edit selected",
            "view_notifications": "View notifications",
            "find": "find",
            "register": "Register",
            "cancelled": "Cancelled",
            "sold": "Sold",
            "invoiced": "Invoiced",
            "paid": "Paid",
            "pending": "Pending",
            "approved": "Approved",
            "received": "Received",
            "send": "Sent",
            "partiallypaid": "Part payment",
            "partiallyinvoiced": "Part invoiced",
            "partial_delivery": "Partially delivered",
            "delivery_completed": "Delivery completed",
            "action_sold": "Sell",
            "action_invoiced": "Invoice",
            "action_paid": "Pay",
            "action_approved": "Approved",
            "action_received": "Received",
            "action_send": "Send",
            "action_active": "Active",
            "action_inactive": "Inactive",
            "add_signature": "Add Sign Image",
            "digits_card": "Card termination",
            "digits_card_placeholder": "Enter the last 4 digits",
            "resumen": "Summary of receptions",
            "resumen_supplier_shipping": "Summary of Supplier shipping",
            "revice": "Receive",
            "supplier_shipping": "Supplier shipping",
            "invoicePayment ": "Payment",
            "shipment": "parcel delivery: ",
            "shippments": "Supplier shipments",
            "details": "Detail",
            "sendings": "Sendings",
            "prospecting": "Prospecting",
            "prospectings": "Prospectings",
            "lead": "Lead",
            "reports": "Reportes",
            "prospectings_inactived": "Prospect Inactivity",
            "contacted_from": "No contact from:",
            "supplier_quotations": "Supplier Quotations",
            "not_defined": "Not defined",
            "resume": "Resume"
        },
        "supplier_shippment": {
            "parcel": "Parcel",
            "guide_number": "Guide Number",
            "arrival_date": "Arrival Date",
            "product": "Product",
            "quantity_ordered": "Quantity Ordered",
            "quantity_sent": "Quantity Sent",
            "created_at": "Shipping Date",
            "created_by": "Created by:",
            "purchase_order": "Purchase Order",
            "supplier": "Supplier",
            "quantity_received": "Quantity Received"
        },
        "suppliers": {
            "add": "Add supplier",
            "edit": "Edit supplier",
            "delete": "Delete supplier",
            "not_find": "Can not find a supplier with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the supplier's name",
            "contact": "Contact",
            "contact_placeholder": "Enter the supplier's contact",
            "address": "Address",
            "address_placeholder": "Enter the supplier's address",
            "has_rfc": "This suppliers are in US?",
            "rfc": "RFC",
            "rfc_placeholder": "Enter the supplier's RFC",
            "phone": "Phone Number",
            "phone_placeholder": "Enter the supplier's phone number",
            "country": "Country",
            "country_placeholder": "Enter the supplier's country",
            "billing_address_id": "Billing Address",
            "billing_address_id_placeholder": "Enter the supplier's billing address",
            "created_at": "Created at",
            "report_title": "Suppliers Report"
        },
        "task_attachments": {
            "add": "Add taskAttachment",
            "edit": "Edit taskAttachment",
            "delete": "Delete taskAttachment",
            "not_find": "Can not find taskAttachment with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the taskAttachment's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "TaskAttachments Report"
        },
        "tasks": {
            "add": "Nueva Tarea",
            "edit": "Edit task",
            "delete": "Delete task",
            "not_find": "Can not find task with this code.",
            "tasks": "Tareas",
            "id": "Id",
            "folio": "folio",
            "type": "tipo",
            "task": "tarea",
            "start_date": "DIA\/HORA",
            "end_date": "Vencimiento",
            "name": "Tarea",
            "name_placeholder": "Enter the task's name",
            "status": "STATUS",
            "desc_task": "Descripcion de tarea",
            "created_by": "Creada por",
            "created_at": "Created at",
            "report_title": "Tasks Report",
            "sell": "Venta",
            "client": "Cliente",
            "quotation": "Cotizacion",
            "seller": "Vendedor",
            "expire": "Vencimiento",
            "oc": "Orden de Compras",
            "inProgressStatus": "Tarea Resumida",
            "finishedStatus": "Tarea Finalizada",
            "task_updated": "Tarea Actualizada",
            "task_created": "Tarea Creada"
        },
        "units_measurement": {
            "add": "Add measurement unit",
            "edit": "Edit measurement unit",
            "delete": "Delete measurement unit",
            "not_find": "Can not find a measurement unit with this code.",
            "id": "Id",
            "code": "Code",
            "code_placeholder": "Enter the measurement unit's code",
            "name": "Name",
            "name_placeholder": "Enter the measurement unit's name",
            "symbol": "Symbol",
            "symbol_placeholder": "Enter the measurement unit's symbol",
            "created_at": "Created at",
            "report_title": "Measurement Units Report"
        },
        "users": {
            "add": "Add user",
            "edit": "Edit user",
            "delete": "Delete user",
            "not_find": "Can not find user with this code.",
            "actived_error": "User is already active",
            "inactived_error": "User is already inactive",
            "actived": "User has been activated",
            "inactived": "User has been inactivated",
            "active": "Active",
            "inactive": "Inactive",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the user's name",
            "email": "Email",
            "email_placeholder": "Enter the user's email",
            "password": "Password",
            "password_placeholder": "Enter the user's password",
            "confirm_password": "Confirm Password",
            "confirm_password_placeholder": "Enter the user's confirm password",
            "role": "Role",
            "role_placeholder": "Enter the user's role",
            "status": "Status",
            "leave_empty": "Leave empty to keep the current password",
            "created_at": "Created at",
            "report_title": "Users Report"
        },
        "validation": {
            "accepted": "The :attribute must be accepted.",
            "active_url": "The :attribute is not a valid URL.",
            "after": "The :attribute must be a date after :date.",
            "after_or_equal": "The :attribute must be a date after or equal to :date.",
            "alpha": "The :attribute may only contain letters.",
            "alpha_dash": "The :attribute may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The :attribute may only contain letters and numbers.",
            "array": "The :attribute must be an array.",
            "before": "The :attribute must be a date before :date.",
            "before_or_equal": "The :attribute must be a date before or equal to :date.",
            "between": {
                "numeric": "The :attribute must be between :min and :max.",
                "file": "The :attribute must be between :min and :max kilobytes.",
                "string": "The :attribute must be between :min and :max characters.",
                "array": "The :attribute must have between :min and :max items."
            },
            "boolean": "The :attribute field must be true or false.",
            "confirmed": "The :attribute confirmation does not match.",
            "date": "The :attribute is not a valid date.",
            "date_format": "The :attribute does not match the format :format.",
            "different": "The :attribute and :other must be different.",
            "digits": "The :attribute must be :digits digits.",
            "digits_between": "The :attribute must be between :min and :max digits.",
            "dimensions": "The :attribute has invalid image dimensions.",
            "distinct": "The :attribute field has a duplicate value.",
            "email": "The :attribute must be a valid email address.",
            "exists": "The selected :attribute is invalid.",
            "file": "The :attribute must be a file.",
            "filled": "The :attribute field must have a value.",
            "gt": {
                "numeric": "The :attribute must be greater than :value.",
                "file": "The :attribute must be greater than :value kilobytes.",
                "string": "The :attribute must be greater than :value characters.",
                "array": "The :attribute must have more than :value items."
            },
            "gte": {
                "numeric": "The :attribute must be greater than or equal :value.",
                "file": "The :attribute must be greater than or equal :value kilobytes.",
                "string": "The :attribute must be greater than or equal :value characters.",
                "array": "The :attribute must have :value items or more."
            },
            "image": "The :attribute must be an image.",
            "in": "The selected :attribute is invalid.",
            "in_array": "The :attribute field does not exist in :other.",
            "integer": "The :attribute must be an integer.",
            "ip": "The :attribute must be a valid IP address.",
            "ipv4": "The :attribute must be a valid IPv4 address.",
            "ipv6": "The :attribute must be a valid IPv6 address.",
            "json": "The :attribute must be a valid JSON string.",
            "lt": {
                "numeric": "The :attribute must be less than :value.",
                "file": "The :attribute must be less than :value kilobytes.",
                "string": "The :attribute must be less than :value characters.",
                "array": "The :attribute must have less than :value items."
            },
            "lte": {
                "numeric": "The :attribute must be less than or equal :value.",
                "file": "The :attribute must be less than or equal :value kilobytes.",
                "string": "The :attribute must be less than or equal :value characters.",
                "array": "The :attribute must not have more than :value items."
            },
            "max": {
                "numeric": "The :attribute may not be greater than :max.",
                "file": "The :attribute may not be greater than :max kilobytes.",
                "string": "The :attribute may not be greater than :max characters.",
                "array": "The :attribute may not have more than :max items."
            },
            "mimes": "The :attribute must be a file of type: :values.",
            "mimetypes": "The :attribute must be a file of type: :values.",
            "min": {
                "numeric": "The :attribute must be at least :min.",
                "file": "The :attribute must be at least :min kilobytes.",
                "string": "The :attribute must be at least :min characters.",
                "array": "The :attribute must have at least :min items."
            },
            "not_in": "The selected :attribute is invalid.",
            "not_regex": "The :attribute format is invalid.",
            "numeric": "The :attribute must be a number.",
            "present": "The :attribute field must be present.",
            "regex": "The :attribute format is invalid.",
            "required": "The :attribute field is required.",
            "required_if": "The :attribute field is required when :other is :value.",
            "required_unless": "The :attribute field is required unless :other is in :values.",
            "required_with": "The :attribute field is required when :values is present.",
            "required_with_all": "The :attribute field is required when :values is present.",
            "required_without": "The :attribute field is required when :values is not present.",
            "required_without_all": "The :attribute field is required when none of :values are present.",
            "same": "The :attribute and :other must match.",
            "size": {
                "numeric": "The :attribute must be :size.",
                "file": "The :attribute must be :size kilobytes.",
                "string": "The :attribute must be :size characters.",
                "array": "The :attribute must contain :size items."
            },
            "string": "The :attribute must be a string.",
            "timezone": "The :attribute must be a valid zone.",
            "unique": "The :attribute has already been taken.",
            "uploaded": "The :attribute failed to upload.",
            "url": "The :attribute format is invalid.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "verification": {
            "title": "Verify your Email Address",
            "check_email": "Check the inbox to finish the registration.",
            "check_email_label": "Check the email to finish the registration. We have sent you a registration link to the address:",
            "resend_email": "You have not received the registration link? Resend",
            "resend_succesfully": "Successfully resend",
            "reset_email": "Change email address"
        },
        "welcome": {
            "subject": "Welcome to Controlla",
            "line_1": "Welcome to controlla.",
            "action": "Start now"
        }
    }
};